<!-- @veltra/icons generated sha256:0c27e27609066bb1 gen:8 source:src/svg/normal/align-bottom.svg -->
<script setup lang="ts">
defineOptions({ name: 'AlignBottom' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M3.5 6.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0m2.5 7v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-1 0m4.5 0v-7a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0m2.5 0v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-1 0"
    />
  </svg>
</template>
